import { httpClient } from "./httpClient";

const getVendorEWFSetting = () => {
    return httpClient.get("vendor-employee-welfare-fund");
};

const getEmployeeEWFByidEmp = (idEmp) => {
    return httpClient.get("employee-welfare-fund/employee", { params: idEmp ? { id: idEmp } : {}});
};

const joinEmployeeEWF = (data) => {
    return httpClient.post("employee-welfare-fund/join", data);
};

const leftEmployeeEWF = (data) => {
    return httpClient.put("employee-welfare-fund/left", data);
}

const dumpExcelEmployeeWelfareFundByVendor = (data) => {
    return httpClient.put("upload-excel/employee-welfare-fund", data);
};

export default {
    getVendorEWFSetting,
    getEmployeeEWFByidEmp,
    joinEmployeeEWF,
    leftEmployeeEWF,
    dumpExcelEmployeeWelfareFundByVendor
};